import { render, staticRenderFns } from "./AnalysisFourth.vue?vue&type=template&id=1b2e73f9&scoped=true"
import script from "./AnalysisFourth.vue?vue&type=script&lang=js"
export * from "./AnalysisFourth.vue?vue&type=script&lang=js"
import style0 from "./AnalysisFourth.vue?vue&type=style&index=0&id=1b2e73f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2e73f9",
  null
  
)

export default component.exports